import React from "react";
import { useLocation, Link } from "react-router-dom";
import "./App.css";

function ThanksPage() {
  const params = new URLSearchParams(useLocation().search);
  const orderId = params.get("order");

  return (
    <div className="thanks-container">
      <div className="thanks-box">
        <div className="thanks-icon">✔</div>
        <h1>Thank You!</h1>
        <p>Your order has been placed successfully.</p>

        {orderId && (
          <p className="order-id">
            <strong>Order ID:</strong> #{orderId}
          </p>
        )}

        <div className="thanks-summary">
          <p>We’ll send you a WhatsApp message with your payment link and delivery details soon.</p>
          <p>Meanwhile, you can track your order from your account.</p>
        </div>

        <div className="thanks-actions">
          <Link to="/" className="btn-primary">Continue Shopping</Link>
        </div>
      </div>
    </div>
  );
}

export default ThanksPage;
